<template>
  <v-card class="ma-2" style="flex: 1 0 auto" v-if="configFtp">
    <v-card-title
      class="pb-0"
      style="flex: 1 0 auto; flex-direction: column; align-items: stretch; position: relative; height: 100%"
    >
      <v-layout class="pb-0" row wrap style="flex: 0 0; align-items: flex-start; border-bottom: 1px solid #ccc">
        <span class="subheading mb-1" style="flex: 0 0 auto">{{ $t('Pilot.FtpRsync.ConfigurationFtp') }}</span>
      </v-layout>
      <div style="flex: 1 0; position: relative">
        <v-layout
          class="pb-0"
          row
          wrap
          style="flex: 1 0; align-items: flex-start; overflow: auto; position: absolute; height: 100%; width: 100%"
        >
          <v-flex xs6 pr-2 class="inline-block">
            <v-text-field hide-details v-model="configFtp.server" :label="$t('Pilot.FtpRsync.Server')" />
            <number-field-factor hide-details v-model.number="configFtp.port" :label="$t('Pilot.FtpRsync.Port')" />
            <v-text-field hide-details v-model="configFtp.login" :label="$t('Pilot.FtpRsync.Login')" />
            <v-text-field hide-details v-model="configFtp.password" :label="$t('Pilot.FtpRsync.Password')" />
            <v-switch
              class="px-0 pb-2 sm-switch"
              hide-details
              v-model="configFtp.tls"
              :label="$t('Pilot.FtpRsync.Tls')"
            />
          </v-flex>
          <v-flex xs6 pl-2 class="inline-block">
            <div class="mt-2">{{ $t('Pilot.FtpRsync.SyncPaths') }} :</div>
            <div class="checkboxGroup">
              <v-checkbox
                hide-details
                v-for="syncPath in SyncPathsArr"
                :key="syncPath"
                class="ml-0 my-0"
                v-model="configFtp.syncPaths"
                :title="$t(`Pilot.FtpRsync.${syncPath}Tooltip`)"
                :label="syncPath"
                :value="syncPath"
                style="flex: 0 0 !important; min-width: 51px; min-height: 20px"
              >
              </v-checkbox>
            </div>
            <v-text-field hide-details v-model="configFtp.dstPaths" :label="$t('Pilot.FtpRsync.DstPaths')" />
          </v-flex>
        </v-layout>
      </div>
      <v-layout class="pt-0" row wrap style="flex: 0 0; align-items: flex-start">
        <v-spacer />
        <v-btn @click.prevent="restoreConfigFtp()" small
          >{{ $t('Fleet.Clear') }}<v-icon small right>mdi-replay</v-icon></v-btn
        >
        <v-btn @click.prevent="applyToAll()" :loading="saving" :disabled="saving" small color="primary"
          >{{ $t('Fleet.ApplyToAll') }}<v-icon small right>mdi-content-save</v-icon></v-btn
        >
      </v-layout>
    </v-card-title>
  </v-card>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, nextTick } from 'vue'
import { SyncPathsArr } from '@/enum/SyncPath'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import store from '@/store'

const props = defineProps<{
  fleet: AloDbFleet
}>()

const configFtp = computed(() => store.state.fleet.context?.configFtp)

onMounted(() => {
  if (!store.state.fleet.context?.configFtp || store.state.fleet.context.configFtp.idFleet != props.fleet.id) {
    restoreConfigFtp()
  }
})

const saving = ref(false)

const missions = computed(
  () => props.fleet.activeMissionIds?.map((id) => store.myGetters?.missionsById[id])?.filter((m) => !!m) ?? []
)

function restoreConfigFtp() {
  store.state.fleet.context.configFtp = {
    idFleet: props.fleet.id,
    login: '',
    password: '',
    port: 21,
    server: '',
    tls: true,
    dstPaths: '',
    syncPaths: [] as string[]
  }
}

async function applyToAll() {
  if (saving.value) return
  saving.value = true

  for (const mission of missions.value.filter((m) => m.misActifOn)) {
    if (mission.gliId == null) return
    try {
      await store.myActions.GLIDER_IRIS_FTP_REQUEST(mission.gliId!)
      await store.myActions.GLIDER_UPDATE_MODIFIED_FTP({
        itemId: mission.gliId!,
        newProperties: {
          mod_settings: {
            FTP: {
              login: configFtp.value.login,
              password: configFtp.value.password,
              port: configFtp.value.port,
              server: configFtp.value.server,
              tls: configFtp.value.tls
            },
            Data: {
              dst_paths: configFtp.value.dstPaths,
              sync_paths: configFtp.value.syncPaths.filter((p: any) => SyncPathsArr.some((pa) => pa == p))
            }
          }
        }
      })
      await store.myActions.GLIDER_IRIS_FTP_SAVE_REQUEST(mission.gliId!)
    } catch (e) {
      console.error(e)
    }
  }
  nextTick(() => {
    restoreConfigFtp()
    saving.value = false
  })
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.subheading {
  font-weight: bold;
}

.checkboxGroup {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
}
</style>

<style>
.checkboxGroup .v-input__control {
  transform: scale(0.63);
  transform-origin: 0 0;
  position: absolute;
  min-width: fit-content;
  font-weight: bold;
  white-space: nowrap;
}

.radioGroup .v-input--radio-group__input {
  flex-direction: row;
  min-width: fit-content;
  display: flex;
  position: relative;
  flex-wrap: wrap;
}
</style>
